<template>
  <div class="enrolling-query-export" v-loading="loading" element-loading-text="页面加载中，请稍等...">
    <div class="export-info">
      <div class="form" v-loading="exporting" element-loading-text="数据导出中，请稍等...">
        <span>选择批次：</span>
        <el-select v-model="batchId"
                   filterable
                   clearable>
          <template v-if="batchList">
            <el-option v-for="data in batchList"
                       :key="data.id"
                       :value="data.id"
                       :label="data.name"></el-option>
          </template>
        </el-select>
      </div>
      <div class="footer">
        <el-button type="primary" size="mini" :disabled="exporting" @click="exportData">导出</el-button>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'EnrollingQueryExport',
  data () {
    return {
      loading: false,
      exporting: false,
      batchId: null,
      batchList: []
    }
  },
  methods: {
    loadBatchList () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/query/batchList',
        method: 'POST'
      }).then(response => {
        if (response.data) {
          const res = response.data
          if (res.errorCode === 0) {
            this.batchList = res.batchList || []
          } else {
            this.$message.error(res.message)
          }
        }
      }, () => {
        this.$message.error('获取批次信息失败')
      }).finally(() => {
        this.loading = false
      })
    },
    exportData () {
      if (!this.batchId) {
        this.$message.error('请先选择批次')
        return
      }
      this.exporting = true
      this.$ajax({
        url: '/workspace/manager/enrolling/query/export',
        method: 'POST',
        data: this.$qs.stringify({
          batchId: this.batchId
        })
      }).then(response => {
        if (response.data) {
          const res = response.data
          if (res.errorCode === 0) {
            window.location.href = res.path
          } else {
            this.$message.error(res.message)
          }
        }
      }, () => {
        this.$message.error('导出失败')
      }).finally(() => {
        this.exporting = false
      })
    }
  },
  mounted () {
    this.loadBatchList()
  }
}
</script>

<style>
.enrolling-query-export {
  height: 100%;
  .export-info {
    height: 100%;
    display: flex;
    flex-direction: column;
    .form {
      display: flex;
      height: 80%;
      justify-content: center;
      align-items: center;
    }
    .footer {
      flex: auto;
      display: flex;
      align-items: center;
      background-color: white;
      justify-content: center;
    }
  }
}
</style>
